import { render, staticRenderFns } from "./ColumnHeaderFilter.vue?vue&type=template&id=0712350f&scoped=true&"
import script from "./ColumnHeaderFilter.vue?vue&type=script&lang=ts&"
export * from "./ColumnHeaderFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0712350f",
  null
  
)

export default component.exports